/* ==================================================================
   bp-overrides.js · complete file · v8.49 (20 Jul 2026)
   Single clean copy (previous paste was accidentally duplicated).
   Adds v8.49 quiz-result CTA at the end.
   ================================================================== */
(function () {
  'use strict';
  var ann = document.querySelector('.announce');
  var hdr = document.querySelector('.kstick') || document.querySelector('header');
  function measure() {
    if (ann) document.documentElement.style.setProperty('--annH', ann.offsetHeight + 'px');
    if (hdr) document.documentElement.style.setProperty('--hdrH', hdr.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  /* Smart header: hide scrolling down, show scrolling up; pill never covered */
  if (hdr) {
    var getY = function () {
      return window.scrollY || (document.scrollingElement && document.scrollingElement.scrollTop) || document.documentElement.scrollTop || 0;
    };
    var lastY = getY(), idleTimer = null;
    var reveal = function () { hdr.classList.remove('hdr-hidden'); };
    var onScroll = function () {
      var y = getY();
      if (y > 160 && y > lastY + 2) hdr.classList.add('hdr-hidden');   /* moving down: hide */
      else if (y < lastY - 2 || y <= 160) reveal();                     /* moving up or near top: show */
      lastY = y;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(reveal, 450);                              /* stopped: show */
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('touchend', function(){ clearTimeout(idleTimer); idleTimer = setTimeout(reveal, 450); }, { passive: true });
    /* watchdog: if the page hasn't moved for 500ms, the header must be visible */
    var wdY = getY();
    setInterval(function () {
      var y = getY();
      if (y === wdY) reveal();
      wdY = y;
    }, 500);
  }
  /* Smooth scroll for /#anchor links when target on this page */
  document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(2));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
  /* Fix anchor landing after cross-page navigation (layout shifts from lazy content) */
  if (location.hash) {
    var target = function () { return document.getElementById(location.hash.slice(1)); };
    window.addEventListener('load', function () {
      var t = target();
      if (t) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 350);
    });
  }
})();
/* ===== v8.24 Instagram-style reels: autoplay muted in view, loop, tap to unmute, pause offscreen ===== */
(function () {
  'use strict';
  var items = [];
  document.querySelectorAll('.mm-reel').forEach(function (btn) {
    var src = (btn.getAttribute('data-reel') || '').trim();
    if (!src) return;                       /* no reel yet: original coming-soon tap stays */
    btn.onclick = null;                     /* replace open-player behavior */
    var v = document.createElement('video');
    v.dataset.src = src; v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.preload = 'metadata';
    v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit';
    var badge = document.createElement('span');
    badge.className = 'reel-sound'; badge.textContent = '\uD83D\uDD07';
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    btn.appendChild(v); btn.appendChild(badge);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      v.muted = !v.muted;
      badge.textContent = v.muted ? '\uD83D\uDD07' : '\uD83D\uDD0A';
      if (v.paused) v.play().catch(function () {});
    });
    items.push({ btn: btn, v: v, badge: badge });
  });
  if (!items.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var it = items.filter(function (a) { return a.btn === en.target; })[0];
      if (!it) return;
      if (en.isIntersecting) {
        if (!it.v.src && it.v.dataset.src) it.v.src = it.v.dataset.src;   /* mount on first sight */
        it.v.play().catch(function () {});
      }
      else { it.v.pause(); it.v.muted = true; it.badge.textContent = '\uD83D\uDD07'; }
    });
  }, { threshold: 0.5 });
  items.forEach(function (a) { io.observe(a.btn); });
})();
/* v8.25: Account opens the real Shopify login/account */
window.openAcct = function () { window.location.href = '/account'; };
/* ===== v8.26 body scroll lock while any overlay is open ===== */
(function () {
  'use strict';
  var SELECTOR = '.nav-drawer.open, .cart-drawer.open, .lightbox.open, #cartOverlay.open, .acct-sheet.open, .acct-sheet.show, .vv__overlay.open, .vv__overlay.show';
  var locked = false, savedY = 0;
  function check() {
    var anyOpen = !!document.querySelector(SELECTOR);
    if (anyOpen && !locked) {
      savedY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-savedY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.documentElement.classList.add('kei-lock');
      locked = true;
    } else if (!anyOpen && locked) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.documentElement.classList.remove('kei-lock');
      window.scrollTo(0, savedY);
      locked = false;
    }
  }
  var mo = new MutationObserver(check);
  mo.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
  check();
})();
/* ===== v8.35 PDP swipe gallery: snap slides, round dots, thumbs jump ===== */
(function () {
  var sw = document.getElementById('pdpSwipe');
  if (!sw) return;
  var slides = sw.querySelectorAll('.pdp-slide');
  var dotsBox = document.getElementById('pdpDots');
  var thumbs = document.querySelectorAll('.pdp-thumb');
  if (slides.length < 2) { if (dotsBox) dotsBox.style.display = 'none'; return; }
  var dots = [];
  slides.forEach(function (_, i) {
    var d = document.createElement('span');
    d.className = 'pdp-dot' + (i === 0 ? ' on' : '');
    d.addEventListener('click', function () { go(i); });
    dotsBox.appendChild(d); dots.push(d);
  });
  function mark(i) {
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    thumbs.forEach(function (t, k) { t.classList.toggle('active', k === i); });
  }
  function go(i) { sw.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
  var ticking = false;
  sw.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var i = Math.round(sw.scrollLeft / sw.clientWidth);
      mark(Math.max(0, Math.min(slides.length - 1, i)));
      ticking = false;
    });
  }, { passive: true });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); }); });
})();
/* v8.37 cart tab badge pops on change */
(function () {
  var b = document.querySelector('.ktabs .kt-count');
  if (!b) return;
  var mo = new MutationObserver(function () {
    b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
  });
  mo.observe(b, { childList: true, characterData: true, subtree: true });
})();
/* ===== v8.41 zoom + copy deterrents ===== */
(function () {
  'use strict';
  window.addEventListener('wheel', function (e) { if (e.ctrlKey) e.preventDefault(); }, { passive: false });
  document.addEventListener('gesturestart', function (e) { e.preventDefault(); });
  document.addEventListener('gesturechange', function (e) { e.preventDefault(); });
  document.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) e.preventDefault();
  });
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('input,textarea')) return;
    e.preventDefault();
  });
  document.addEventListener('copy', function (e) {
    if (e.target.closest('input,textarea')) return;
    e.preventDefault();
  });
})();
/* ===== v8.42 promo rail: dots sync + auto-advance ===== */
(function () {
  'use strict';
  var rail = document.querySelector('.krail');
  if (!rail) return;
  var cards = rail.querySelectorAll('.kcard');
  var dotsBox = document.querySelector('[data-krail-dots]');
  if (cards.length < 2) { if (dotsBox) dotsBox.style.display = 'none'; return; }
  var dots = [];
  cards.forEach(function (_, i) {
    var d = document.createElement('span'); d.className = 'krail-dot' + (i ? '' : ' on');
    d.addEventListener('click', function () { go(i); });
    dotsBox.appendChild(d); dots.push(d);
  });
  var idx = 0, paused = false;
  function go(i) { idx = (i + cards.length) % cards.length; rail.scrollTo({ left: cards[idx].offsetLeft - rail.offsetLeft - 20, behavior: 'smooth' }); }
  rail.addEventListener('scroll', function () {
    var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = 1e9;
    cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - rail.offsetLeft - mid); if (d < bd) { bd = d; best = i; } });
    idx = best; dots.forEach(function (d, k) { d.classList.toggle('on', k === best); });
  }, { passive: true });
  ['touchstart', 'mouseenter'].forEach(function (ev) { rail.addEventListener(ev, function () { paused = true; }, { passive: true }); });
  ['touchend', 'mouseleave'].forEach(function (ev) { rail.addEventListener(ev, function () { paused = false; }, { passive: true }); });
  setInterval(function () { if (!paused && !document.hidden) go(idx + 1); }, 5000);
})();
/* ==================================================================
   v8.43-45 · Memory Wall + navigation
   A) Memory Wall in desktop header + mobile tab bar
   B) Homepage Memory Wall teaser section
   C) Memory Wall v3: AI suggests only (never auto-selects), works on
      paste, posts contact[Emotion], AJAX submit keeps customer on the
      wall, inline validation, lastVal fix.
   ================================================================== */
/* ---------- A · Memory Wall discovery in navigation ---------- */
(function () {
  'use strict';
  /* Desktop header — after the Mood Quiz ("Play") link */
  var nl = document.querySelector('.nav-links');
  var ct = nl && nl.querySelector('a[href="/pages/contact"]');
  if (ct) ct.remove();
  if (nl && !nl.querySelector('a[href="/pages/memory-wall"]')) {
    var a = document.createElement('a');
    a.href = '/pages/memory-wall';
    a.textContent = 'Memory Wall';
    var play = nl.querySelector('a[href="/pages/which-mood-are-you"]');
    if (play) { play.insertAdjacentElement('afterend', a); } else { nl.appendChild(a); }
  }
  /* Mobile bottom tab bar — Wall before Cart */
  var kb = document.querySelector('nav.ktabs');
  if (kb && !kb.querySelector('a[href="/pages/memory-wall"]')) {
    var t = document.createElement('a');
    t.href = '/pages/memory-wall';
    t.className = 'kt' + (location.pathname.indexOf('/pages/memory-wall') === 0 ? ' on' : '');
    t.innerHTML = '<span>\uD83C\uDFC6</span>Wall';
    var cart = kb.querySelector('a[href="/cart"]');
    if (cart) { kb.insertBefore(t, cart); } else { kb.appendChild(t); }
  }
})();
/* ---------- B · Homepage teaser for the Memory Wall ---------- */
(function () {
  'use strict';
  if (!document.body.classList.contains('tpl-index')) return; /* homepage only */
  if (document.getElementById('memory-teaser')) return;
  var refill = document.querySelector('.refill');
  var anchor = refill && refill.closest('.shopify-section');
  if (!anchor) return;
  var s = document.createElement('section');
  s.className = 'wrap';
  s.id = 'memory-teaser';
  s.style.cssText = 'padding:56px 0;text-align:center';
  s.innerHTML =
    '<p class="eyebrow">The Memory Wall</p>' +
    '<h2>Every scent holds a memory.</h2>' +
    '<div class="rev-grid" style="margin:28px 0;text-align:left">' +
      '<div class="mem-card" style="--mtint:var(--woodveil)">' +
        '<p>\u201CNani ke ghar ki baarish, chai, aur woh purani khidki \u2014 sab yaad aa gaya.\u201D</p>' +
        '<span class="emo-pill">\uD83D\uDD56 Nostalgia</span>' +
        '<div class="who">From our founding circle</div>' +
      '</div>' +
      '<div class="mem-card" style="--mtint:var(--amorven)">' +
        '<p>\u201CHe proposed at Marine Drive. Every jasmine evening since smells like yes.\u201D</p>' +
        '<span class="emo-pill">\uD83C\uDF39 Romance</span>' +
        '<div class="who">From our founding circle</div>' +
      '</div>' +
    '</div>' +
    '<a class="btn btn-solid" href="/pages/memory-wall">Share yours \u00B7 best memory wins a \u20B9656 gift set</a>';
  anchor.parentNode.insertBefore(s, anchor);
})();
/* ---------- C · Memory Wall v3 ---------- */
(function () {
  'use strict';
  var oldTa = document.getElementById('memText');
  if (!oldTa) return;
  /* Clone the whole FORM: drops every listener blueprint-3 attached
     (auto-select scanners, chip onclicks), so only v3 logic runs. */
  var oldForm = oldTa.closest('form');
  if (!oldForm) return;
  var form = oldForm.cloneNode(true);
  oldForm.parentNode.replaceChild(form, oldForm);
  var ta      = form.querySelector('#memText');
  var scent   = form.querySelector('#memScent');
  var who     = form.querySelector('#memWho');
  var chips   = form.querySelector('#emoChips') || document.getElementById('emoChips');
  var hint    = document.getElementById('aiHint');
  var counter = document.getElementById('memN');
  var wall    = document.getElementById('memWall');
  if (!ta || !scent || !chips || !hint) return;
  ta.removeAttribute('oninput');
  if (scent.options.length && !scent.options[0].value) {
    scent.options[0].text = 'Which scent matches your memory?';
  }
  var EMOS = { Love:'\u2764\uFE0F', Nostalgia:'\uD83D\uDD56', Joy:'\u2600\uFE0F',
               Calm:'\uD83C\uDF3F', Romance:'\uD83C\uDF39', Home:'\uD83C\uDFE0',
               Adventure:'\uD83C\uDF0A', Peace:'\uD83D\uDD4A\uFE0F' };
  var NAMES = { sunflare:'Sunflare', aqualume:'Aqualume', floranta:'Floranta',
                woodveil:'Woodveil', amorven:'Amorven', dusktime:'Dusktime' };
  var KW = {
    Love:      ['love','pyaar','pyar','jaan','dil','mohabbat','ishq','crush','propose','forever','hamesha','first love'],
    Romance:   ['roka','shaadi','shadi','wedding','date','kiss','gajra','honeymoon','valentine','candle','mehendi','sagai','partner','husband','wife','boyfriend','girlfriend','jasmine'],
    Nostalgia: ['nani','dadi','dada','nana','childhood','school','college','old ','bachpan','yaad','memor','grandmother','grandfather','purani','purana','90s','cassette','vacation','hostel'],
    Home:      ['home','ghar','maa','mummy','mom','dad','papa','kitchen','family','balcony','terrace','gully','mohalla','rasoi','khana'],
    Joy:       ['laugh','hasna','smile','happy','khushi','diwali','holi','festival','dance','party','celebrat','birthday','jeet','won','win '],
    Calm:      ['rain','baarish','barish','monsoon','coffee','chai','evening','shaam','quiet','sukoon','peace ','slow','breeze','hawa','khidki','window','book'],
    Adventure: ['beach','travel','trip','mountain','pahad','trek','goa','flight','road','sea','samundar','ocean','manali','ladakh','bike','safar','train'],
    Peace:     ['temple','mandir','prayer','pooja','puja','aarti','meditation','silence','diya','agarbatti','church','gurudwara','dargah','subah','morning']
  };
  var sel = null, suggested = null, timer = null, lastVal = null;
  var emoInput = form.querySelector('input[name="contact[Emotion]"]');
  if (!emoInput) {
    emoInput = document.createElement('input');
    emoInput.type = 'hidden';
    emoInput.name = 'contact[Emotion]';
    form.appendChild(emoInput);
  }
  function esc(s){ return s.replace(/</g, '&lt;'); }
  function detect(t) {
    t = ' ' + t.toLowerCase() + ' ';
    var best = null, bs = 0;
    Object.keys(KW).forEach(function (e) {
      var s = 0;
      KW[e].forEach(function (k) { if (t.indexOf(k) > -1) s++; });
      if (s > bs) { bs = s; best = e; }
    });
    return bs > 0 ? best : null;
  }
  function render(pop) {
    chips.innerHTML = '';
    Object.keys(EMOS).forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = EMOS[e] + ' ' + e +
        (e === suggested && e !== sel ? ' <span class="aisug">\u2728 AI</span>' : '');
      b.className = (e === sel ? 'sel' : '') +
                    (e === suggested && e !== sel ? ' suggested' : '') +
                    (e === pop ? ' popc' : '');
      b.onclick = function () {
        sel = e; emoInput.value = e;
        hint.classList.remove('warn');
        hint.innerHTML = 'You picked <b>' + e + '</b>.';
        render();
      };
      chips.appendChild(b);
    });
  }
  function scan() {
    if (sel) return;                       /* never override a manual pick   */
    var v = ta.value.trim();
    if (v === lastVal) return;             /* don't clobber warnings on blur */
    lastVal = v;
    hint.classList.remove('warn');
    if (v.length < 8) {
      suggested = null; render();
      hint.innerHTML = '\u2728 AI will suggest a mood as you write\u2026';
      return;
    }
    var d = detect(v);
    if (d) {
      var changed = d !== suggested;
      suggested = d; render(changed ? d : null);
      hint.innerHTML = '\u2728 AI suggests <b>' + d + '</b> \u2014 tap the chip to accept, or pick any other.';
    } else {
      hint.innerHTML = '\u2728 AI is reading\u2026 keep writing, or tap a mood yourself.';
    }
  }
  ['input', 'change', 'paste'].forEach(function (ev) {
    ta.addEventListener(ev, function () {
      if (counter) counter.textContent = Math.max(0, 280 - ta.value.length);
      clearTimeout(timer);
      timer = setTimeout(scan, 300);
    });
  });
  function warn(msg, el) {
    hint.classList.add('warn');
    hint.innerHTML = '\u26A0\uFE0F ' + msg;
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (el && el.focus) try { el.focus({ preventScroll: true }); } catch (e) {}
  }
  form.addEventListener('submit', function (ev) {
    if (!scent.value) { ev.preventDefault(); warn('Pick which scent this memory belongs to.', scent); return; }
    if (ta.value.trim().length < 8) { ev.preventDefault(); warn('Write your memory first \u2014 a line or two is enough.', ta); return; }
    if (!sel) {
      ev.preventDefault();
      warn('Tap the mood chip that fits your memory' + (suggested ? ' \u2014 AI suggests ' + suggested : '') + '.', chips);
      return;
    }
    emoInput.value = sel;
    ev.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var btnText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Posting\u2026'; }
    var restore = function () { if (btn) { btn.disabled = false; btn.textContent = btnText; } };
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (r.url && r.url.indexOf('challenge') > -1) { form.submit(); return; }
      if (!r.ok) { form.submit(); return; }
      restore(); success();
    }).catch(function () { form.submit(); });
  });
  function success() {
    var text = ta.value.trim(), name = who ? who.value.trim() : '';
    var card = document.createElement('div');
    card.className = 'mem-card';
    card.style.setProperty('--mtint', 'var(--' + scent.value + ')');
    card.innerHTML =
      '<p>\u201C' + esc(text) + '\u201D</p>' +
      '<span class="scent-tag">' + (NAMES[scent.value] || '') + '</span>' +
      '<span class="emo-pill">' + EMOS[sel] + ' ' + sel + '</span>' +
      '<div class="who">' + (name ? esc(name) : 'Anonymous') +
      ' \u00B7 just now \u00B7 \uD83C\uDFC6 entered this month\u2019s contest</div>';
    if (wall) { wall.insertBefore(card, wall.firstElementChild); card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    document.querySelectorAll('#moodCounts .mc').forEach(function (p) {
      if (p.textContent.indexOf(sel) > -1) {
        var b = p.querySelector('b');
        if (b) b.textContent = (parseInt(b.textContent, 10) || 0) + 1;
        p.classList.add('pop');
      }
    });
    hint.classList.remove('warn');
    hint.innerHTML = '\u2705 Posted! Your memory is on the wall and entered in this month\u2019s contest.';
    form.reset();
    if (counter) counter.textContent = '280';
    sel = null; suggested = null; lastVal = '';
    render();
  }
  render();
  hint.innerHTML = '\u2728 AI will suggest a mood as you write\u2026';
})();
/* ===== v8.46 ad events: AddToCart + InitiateCheckout for the local cart ===== */
(function () {
  'use strict';
  function fire(name, gname, value, item) {
    try { if (window.fbq) fbq('track', name, { value: value, currency: 'INR', content_name: item }); } catch (e) {}
    try { if (window.gtag) gtag('event', gname, { value: value, currency: 'INR', items: [{ item_name: item, price: value }] }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.add-cart, .add-set');
    if (!b) return;
    var name = b.dataset.name || (b.closest('.mood, .col-card, .p-card') || {}).id || 'Keiiarra product';
    var price = parseInt(b.dataset.price, 10) || (b.classList.contains('add-set') ? 656 : 220);
    fire('AddToCart', 'add_to_cart', price, name);
  }, true);
  if (typeof window.keiCheckout === 'function') {
    var orig = window.keiCheckout;
    window.keiCheckout = function () {
      var total = parseInt((document.getElementById('cdTotal') || {}).textContent.replace(/[^\d]/g, ''), 10) || 0;
      fire('InitiateCheckout', 'begin_checkout', total, 'Cart');
      return orig.apply(this, arguments);
    };
  }
})();
/* ===== v8.47 collection mood tabs: wire filtering (chips were dead HTML) ===== */
(function () {
  'use strict';
  var bar = document.querySelector('.moodbar');
  if (!bar) return;
  var chips = Array.from(bar.querySelectorAll('.mood-chip'));
  var cards = Array.from(document.querySelectorAll('.p-card'));
  if (!chips.length || !cards.length) return;
  fetch(location.pathname.replace(/\/$/, '') + '/products.json?limit=250')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var tagMap = {};
      (data.products || []).forEach(function (p) {
        tagMap[p.handle] = (p.tags || []).map(function (t) { return t.toLowerCase(); });
      });
      cards.forEach(function (c) {
        var a = c.querySelector('a[href*="/products/"]');
        var h = a ? (a.getAttribute('href').split('/products/')[1] || '').split(/[/?#]/)[0] : '';
        c.dataset.moods = (tagMap[h] || []).join(',');
      });
      function apply(mood) {
        cards.forEach(function (c) {
          var show = mood === 'all' || (c.dataset.moods || '').split(',').indexOf(mood) > -1;
          c.style.display = show ? '' : 'none';
          var w = c.parentElement;                    /* theme wraps each card in a div */
          if (w && !w.classList.contains('grid')) w.style.display = show ? '' : 'none';
        });
      }
      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          chips.forEach(function (x) { x.classList.remove('on'); });
          ch.classList.add('on');
          var m = ch.dataset.moodFilter || ch.textContent.trim().toLowerCase();
          apply(m);
          setTimeout(function () { apply(m); }, 80);  /* outlast the theme's own broken handler */
        });
      });
      if (chips[0]) chips[0].classList.add('on');
    })
    .catch(function () {});
})();
/* ===== v8.49 Quiz result CTA — turn quiz-finishers into buyers ===== */
(function () {
  'use strict';
  var res = document.getElementById('quizRes');
  var nameEl = document.getElementById('quizName');
  if (!res || !nameEl) return;
  var HANDLES = {
    sunflare: 'sunflare', aqualume: 'aqualume', floranta: 'floranta',
    woodveil: 'woodveil', amorven: 'amorven', dusktime: 'dusktime'
  };
  function injectCTA() {
    if (document.getElementById('quizCTA')) return;
    var scent = (nameEl.textContent || '').trim().toLowerCase();
    var handle = HANDLES[scent];
    var wrap = document.createElement('div');
    wrap.id = 'quizCTA';
    wrap.style.cssText = 'display:grid;gap:10px;margin:18px 0;';

    var primary = document.createElement('a');
    primary.style.cssText = 'display:block;text-align:center;padding:14px 18px;border-radius:6px;' +
      'background:#e9b949;color:#2b0e12;font-weight:700;letter-spacing:.04em;text-decoration:none;';
    if (handle) {
      primary.href = '/products/' + handle;
      primary.textContent = 'Shop ' + nameEl.textContent.trim() + ' \u00B7 \u20B9220';
    } else {
      primary.href = '/pages/try-it-buy-it';
      primary.textContent = 'Shop Your Scent \u00B7 \u20B9220';
    }

    var secondary = document.createElement('a');
    secondary.style.cssText = 'display:block;text-align:center;padding:12px 18px;border-radius:6px;' +
      'background:transparent;color:#fbf5e8;border:2px solid #e9b949;font-weight:600;text-decoration:none;';
    secondary.href = '/pages/try-it-buy-it';
    secondary.textContent = 'Not sure? Try all 6 for \u20B999';

    wrap.appendChild(primary);
    wrap.appendChild(secondary);
    var couponWrap = document.getElementById('couponWrap');
    var leadForm = document.getElementById('leadForm');
    var anchor = leadForm || couponWrap;
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(wrap, anchor); }
    else { res.appendChild(wrap); }
  }
  var mo = new MutationObserver(function () {
    if (getComputedStyle(res).display !== 'none' && nameEl.textContent.trim()) injectCTA();
  });
  mo.observe(res, { attributes: true, childList: true, subtree: true });
  if (getComputedStyle(res).display !== 'none' && nameEl.textContent.trim()) injectCTA();
})();